(function(angular, _) {
    angular.module('GorillaBoy.services')
    .factory('FeedbackLocalStorageService',
        ['localStorageService', 'authenticatedUser',
        FeedbackLocalStorageService
    ]);
    function FeedbackLocalStorageService(localStorageService, authenticatedUser) {
        var LOCAL_DRAFT_COMMENTS_FILENAME = 'local_draft_comments2',
            LOCAL_DRAFT_ANNOTATIONS_FILENAME = 'local_draft_annotations2',
            service = {};

        //delete old key and its data
        localStorageService.remove('local_draft_comments');
        localStorageService.remove('local_draft_annotations');

        function annotationIDMapper(annotation) {
            return annotation.AnnotationId;
        }

        function commentIDMapper(cmnt) {
            return cmnt.CommentId;
        }

        service.deleteCommentIfExists = function(commentID) {
            var localComments = service.readComments();
            var foundIt = false;
            localComments = localComments.filter(function(cmt) {
                var same = (commentID === cmt.CommentId);
                if (!foundIt && same) {
                    foundIt = same;
                }
                return !same;
            });
            localStorageService.set(LOCAL_DRAFT_COMMENTS_FILENAME, JSON.stringify(localComments));
            return foundIt;
        };

        service.deleteAnnotationIfExists = function(annotationID) {
            var localAnnotations = service.readAnnotations();
            var foundIt = false;
            localAnnotations = localAnnotations.filter(function(annotation) {
                var same = (annotationID === annotation.AnnotationId);
                if (!foundIt && same) {
                    foundIt = same;
                }
                return !same;
            });
            localStorageService.set(LOCAL_DRAFT_ANNOTATIONS_FILENAME, JSON.stringify(localAnnotations));
            return foundIt;
        };

        service.writeNewAnnotations = function(annotations) {
            annotations = angular.copy(annotations);
            var localAnnotations = service.readAnnotations();
            var localAnnotationIDs = localAnnotations.map(annotationIDMapper);
            var paramAnnotationIDs = annotations.map(annotationIDMapper);
            var annotationsToBeSaved = _.difference(localAnnotationIDs, paramAnnotationIDs);

            localAnnotations = localAnnotations.filter(function(annotation) {
                return annotationsToBeSaved.indexOf(annotation.AnnotationId) !== -1;
            });
            annotations.forEach(function(annotation) {
                //If we don't delete, there'll be circular dependency and we can't serialize the JSON object
                delete annotation.ParentFeedback;
            });
            localAnnotations = localAnnotations.concat(annotations);
            localStorageService.set(LOCAL_DRAFT_ANNOTATIONS_FILENAME, JSON.stringify(localAnnotations));
        };

        service.readAnnotations = function() {
            return service.readFeedback(LOCAL_DRAFT_ANNOTATIONS_FILENAME);
        };

        service.writeNewComments = function(comments) {
            comments = angular.copy(comments);
            var localComments = service.readComments();
            var localCommentIDs = localComments.map(commentIDMapper);
            var paramCommentIDs = comments.map(commentIDMapper);
            var commentsToBeSaved = _.difference(localCommentIDs, paramCommentIDs);

            localComments = localComments.filter(function(cmt) {
                return commentsToBeSaved.indexOf(cmt.CommentId) !== -1;
            });
            comments.forEach(function(cmt) {
                //If we don't delete, there'll be circular dependency and we can't serialize the JSON object
                delete cmt.ParentFeedback;
            });
            localComments = localComments.concat(comments);
            localStorageService.set(LOCAL_DRAFT_COMMENTS_FILENAME, JSON.stringify(localComments));
        };

        service.readComments = function() {
            return service.readFeedback(LOCAL_DRAFT_COMMENTS_FILENAME);
        };

        service.readFeedback = function(filename) {
            var feedbackListStringified = localStorageService.get(filename),
                feedbackList = [];
            if (feedbackListStringified) {
                feedbackList = (feedbackListStringified);
            }
            return feedbackList;
        };

        return service;
    }
}(angular, _));
